<script lang="ts">
    import { _ } from "svelte-i18n"
    import { postAccessToken } from "../../api"
    import { title } from "../../config"

    import FormInputText from "../widgets/FormInputText.svelte"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import Index from "../SEO/Index.svelte"

    let email = ""
    let success = false
    let loading = false

    const submit = () => {
        loading = true
        postAccessToken({ email })
            .then(() => {
                success = true
            })
            .catch((e) => {
                console.log(e)
                alert($_("my-orders.error"))
            })
            .finally(() => {
                loading = false
            })
    }
</script>

<Index noIndex="{true}" title="{$_('my-orders.my-orders')}" metaDescription="{$_('meta.description')}" />
<section class="section-type-1 section_padding checkout">
    <div class="container">
        <h1>{$_("my-orders.my-orders")}</h1>
        <p>
            {@html $_("my-orders.link-request-intro-html")}
        </p>
        {#if success}
            <p>
                <b>{$_("my-orders.link-request-success")}</b>
            </p>
        {:else}
            <form class="orderform" on:submit|preventDefault="{submit}">
                <div class="row">
                    <div class="col-md-6">
                        <FormInputText name="email" placeholder="E-Mail" required bind:value="{email}" />
                    </div>
                    <div class="col-md-6">
                        {#if loading}
                            <MiniLoader />
                        {:else}
                            <button type="submit" class="btn btn-secondary">{$_("my-orders.send-link")}</button>
                        {/if}
                    </div>
                </div>
            </form>
        {/if}
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";

    .orderform {
        .btn {
            height: 45px;
        }
    }
</style>
